// SHCT-991 — practitioner licence number (med_staff.license_no). Optional; how the hospital
// EMR identifies the doctor. Mirrors the server rule (common-module MedicalLicenseNumber):
// letters / digits / hyphen, 1–20 characters (same set as the patient MRN), empty = none / clear.
// Case is kept as entered — the EMR value is matched exactly.
export const LICENSE_NO_MAX_LENGTH = 20;
export const LICENSE_NO_REGEX = /^[A-Za-z0-9-]{1,20}$/;

// Keystroke filter for the input: keep letters, digits and hyphens, cap at the column length.
export function toLicenseNoInputValue(raw: string): string {
  return raw.replace(/[^A-Za-z0-9-]/g, '').slice(0, LICENSE_NO_MAX_LENGTH);
}
